import { render, staticRenderFns } from "./DataInputText.vue?vue&type=template&id=529eedc5&"
import script from "./DataInputText.vue?vue&type=script&lang=js&"
export * from "./DataInputText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports